import { AxiosInstance } from "axios";
import { URL } from "../../../libraries/http/url";
import { Predicates } from "../../../libraries/predicates/predicates";
import { SearchParams } from "../../../types/search-params";
import { PageableDTO } from "../../../types/pageable";
import useAxios from "../../../utils/useAxios";
import { useEffect, useState } from "react";
import { MasterArtworkNumberState } from "../../../states/meta-artwork/artwork-number/data.type";

type ArtworNumberResponse =
  | PageableDTO<MasterArtworkNumberState[]>
  | MasterArtworkNumberState[];

export const fetchArtworkNumber = async ({
  search,
  axios,
}: SearchParams & { axios: AxiosInstance }) => {
  try {
    const searchParams = URL.createSearchParams({
      search,
      limit: 50,
    });

    const response = await axios.get<ArtworNumberResponse>(
      `/artwork-master/meta-artwork/number/?${searchParams.toString()}`,
    );

    return Predicates.parsePageableReponseToType(response);
  } catch (err) {
    console.error(err);
  }
  return [];
};

export default function useArtworkNumber({ search }: SearchParams) {
  const axios = useAxios();
  const [data, setData] = useState<MasterArtworkNumberState[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  useEffect(() => {
    const getData = async () => {
      setIsLoading(true);
      const response = await fetchArtworkNumber({
        search,
        axios,
      });

      setData(response);
      setIsLoading(false);
    };
    getData();
  }, [search]);

  return { data, isLoading };
}
